export const ENDPOINTS = {
  order: () => `/billing/order`,
  detail: (id) => `/billing/order/${id}`,
  payment: (id) => `/billing/order/${id}/checkout?payment_method=NCB&payment_gate=vnpay`,
  paid: (id) => `/billing/order/${id}/paid-order`
};
